Shop.store.state = {
    filterExpanded: false,
    paymentStatus: "loading"
};